import { useState, useEffect } from "react";
import { client } from "./useContent";

const baseUrl = "https://shrouded-spire-84098.herokuapp.com/";

const fetchData = () => {
  client
    .getEntries()
    .then((response) => {
      console.log(response);
      // setData(response) // getting object
    })
    .catch(console.error);
};

const useFetch = () => {
  //   console.log(url)
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  console.log(data);

  useEffect(() => {
    const fetchData = () => {
      // console.log(data)
      client
        .getEntries()
        .then((response) => {
          console.log(response.items);
          setData(response); // getting object
        })
        .catch(console.error);
    };
    fetchData();
  }, []);

  return { data };
};

export default useFetch;
